import React from "react";

const CheckIcon = ({ className }) => (
  <div className={className}>
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.35813 0.480613L3.98035 4.85884L2.7046 3.63025L2.68103 3.60643C2.06687 2.99245 1.07417 2.99245 0.46062 3.60643C-0.15354 4.22062 -0.15354 5.21293 0.46062 5.82712L0.484188 5.85051L2.84628 8.21306C3.44728 8.84022 4.42896 8.85043 5.04343 8.23624L5.06669 8.21306L10.5785 2.70088L10.5902 2.6894C11.2111 2.06883 11.2056 1.07098 10.5785 0.457013L10.5669 0.445523C9.94602 -0.161857 8.95914 -0.146337 8.35813 0.480613Z"
        fill="white"
      />
    </svg>
  </div>
);

export default CheckIcon;
